import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from '../reducers/reducer';

let store;

export const storeDispatch = (actionCreator) => {
  store.dispatch(actionCreator);
};

export const storeGetState = () => {
  return store.getState();
};

export const getCreateStore = () => {
  store = configureStore({
    reducer: rootReducer(),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
      }),
  });
  return store;
};
